import { render, staticRenderFns } from "./dr-menu-horizontal.vue?vue&type=template&id=d78d10f8&"
import script from "./dr-menu-horizontal.vue?vue&type=script&lang=js&"
export * from "./dr-menu-horizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports